import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const SuccessNotification = ({ 
  isVisible, 
  message, 
  onClose, 
  duration = 5000, 
  type = 'success',
  details = null,
  actionButton = null 
}) => {
  const [isShowing, setIsShowing] = useState(false);

  useEffect(() => {
    if (isVisible) {
      setIsShowing(true);
      const timer = setTimeout(() => {
        setIsShowing(false);
        setTimeout(() => {
          onClose?.();
        }, 300);
      }, duration);
      
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  const getNotificationConfig = () => {
    switch (type) {
      case 'success':
        return {
          bgColor: 'bg-green-50 border-green-200',
          iconColor: 'text-green-600',
          textColor: 'text-green-900',
          detailsColor: 'text-green-800',
          icon: 'CheckCircle'
        };
      case 'warning':
        return {
          bgColor: 'bg-amber-50 border-amber-200',
          iconColor: 'text-amber-600',
          textColor: 'text-amber-900',
          detailsColor: 'text-amber-800',
          icon: 'AlertTriangle'
        };
      case 'info':
        return {
          bgColor: 'bg-blue-50 border-blue-200',
          iconColor: 'text-blue-600',
          textColor: 'text-blue-900',
          detailsColor: 'text-blue-800',
          icon: 'Info'
        };
      case 'error':
        return {
          bgColor: 'bg-red-50 border-red-200',
          iconColor: 'text-red-600',
          textColor: 'text-red-900',
          detailsColor: 'text-red-800',
          icon: 'XCircle'
        };
      default:
        return {
          bgColor: 'bg-green-50 border-green-200',
          iconColor: 'text-green-600',
          textColor: 'text-green-900',
          detailsColor: 'text-green-800',
          icon: 'CheckCircle'
        };
    }
  };

  const config = getNotificationConfig();

  if (!isVisible) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div 
        className={`transform transition-all duration-300 ${
          isShowing ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
        }`}
      >
        <div className={`max-w-md p-4 rounded-lg border shadow-lg ${config?.bgColor}`}>
          <div className="flex items-start space-x-3">
            <Icon 
              name={config?.icon} 
              size={20} 
              className={`mt-0.5 flex-shrink-0 ${config?.iconColor}`} 
            />
            <div className="flex-1">
              <p className={`text-sm font-medium ${config?.textColor}`}>
                {message}
              </p>
              {details && (
                <div className="mt-2">
                  <p className={`text-xs ${config?.detailsColor}`}>
                    {details}
                  </p>
                </div>
              )}
              {actionButton && (
                <div className="mt-3">
                  {actionButton}
                </div>
              )}
            </div>
            <button
              onClick={() => {
                setIsShowing(false);
                setTimeout(() => {
                  onClose?.();
                }, 300);
              }}
              className="p-1 hover:bg-white hover:bg-opacity-20 rounded transition-colors"
            >
              <Icon name="X" size={16} className={config?.iconColor} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessNotification;